// extracted by mini-css-extract-plugin
export default {"title":"delete_title__F8IPs","buttonPart":"delete_buttonPart__uoui9","buttonCancel":"delete_buttonCancel__a3x+A","buttonDelete":"delete_buttonDelete__A9scD"};